import { render, staticRenderFns } from "./list.vue?vue&type=template&id=570a9aef&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=570a9aef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a9aef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570a9aef')) {
      api.createRecord('570a9aef', component.options)
    } else {
      api.reload('570a9aef', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=570a9aef&scoped=true&", function () {
      api.rerender('570a9aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tralvelInfo/list.vue"
export default component.exports